import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";
import Label from "./Label.js";

const template = `
    <div class="v-combobox" v-show="fs.display(input)">
        <div v-if="input.type != 'hidden'" aria-live="polite" aria-atomic="true" class="sr-only" :id="input.id+'_announcer'"></div>
        <qt-label :iuid="iuid" :class="computedLabelClass"></qt-label>
        <input
            :id="input.id"
            :class="computedClass"
            :name="input.element_name"
            type="search"
            :placeholder="input.placeholder"
            :pattern="input.input_pattern"
            :value="input.typed_option"
            @focus="clickAction($event)"
            @input="inputAction($event);"
            @blur="blurAction($event)"
            @keyup.enter.prevent="select(selectedIndex)"
            @keydown.down.prevent="selectNext()"
            @keydown.up.prevent="selectPrev()"
            @keyup.8="handleBackspace()"
            @keyup.27="blurAction($event)"
            @keydown.enter.prevent=""
            :disabled="computedDisable"
            :data-uid="iuid"
            v-bind="input.validation"
            aria-autocomplete="list"
            :aria-controls="input.uid+'_suggestions-list'"
            :aria-expanded="showAutocompleteDropdown"
            :aria-describedby="input.uid+'_error'"
        />
        <transition name="fade" mode="out-in">
            <ul class="v-combobox-option-list scrollbar" v-if="showAutocompleteDropdown" role="listbox" :id="input.id+'_suggestions-list'" :aria-labelledby="input.uid">
                <li :key='index' class="v-combobox-list-item" v-for="(item, index) in filteredItems" @click="select(index)" :class="{'v-combobox-list-item-selected': index == selectedIndex}" role="option" :aria-selected="index == selectedIndex">{{ item.label }}</li>
            </ul>
        </transition>
    </div>
`;

export default {
    name: 'qt-input-combobox',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    data: function () {
        return {
            disabledInput: false,
            placeholder: '',
            selectedIndex: null,
            showAutocompleteDropdown: false,
            time: '',
            //typedOption: '', //John M: coverted this to a combobox element property to enable 2-way databinding.
            scrolledToBottom: false
        }
    },
    components: {
        'qt-label': Label
    },
    watch: {
        "input.typed_option": function (newVal, oldVal) {
            if (newVal.length > 0 && this.filteredItems.length === 0) {
                //this.typedOption = '';
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'typed_option', val: '' });
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: '' });
            }

            if (this.filteredItems.length > 0 && this.filteredLabels.includes(newVal)) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: this.filteredItems[0].label });
            }
        },
        "input.loading": function (newVal, oldVal) {
            this.fs.elementAnnouncer(this.input)
        }
    },
    computed: {
        computedLabelClass: function () {
            var labelClass = []
            if (this.format == 'basic') {
                return '';
            }
            if (this.computedClass) {
                labelClass.push(this.computedClass)

            }
            return labelClass;
        },
        computedClass: function () {
            const classes = ['v-combobox-input'];
            if (this.computedDisable) {
                classes.push(" disabled")
            }
            if (this.input.loading) {
                //classes.push(this.input.loading);
                classes.push(" loading-button")
            }
            return classes;
        },
        computedDisable: function () {
            if (this.input.options.length <= 1 || this.input.disabled || this.input.loading) {
                if (this.input.options.length === 0) {
                    return true;
                }
                if (this.input.options[0] && this.input.options[0].value == "") {
                    // only one and is blank. makes sense for it to be disabled bc it has literally no data
                    return true;
                }
            }
        },
        validationRules: function () {
            return this.input.validation;
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        filteredItems: function () {
            const filteredItems = this.input.options.filter(item => {
                return item.label.toString().toLowerCase().indexOf(this.input.typed_option.toString().toLowerCase()) !== -1;
            });

            if (this.alwaysShowItems.length) {
                this.alwaysShowItems.forEach(item => {
                    filteredItems.push(item);
                });
            }

            // Fancy way to remove dupes from the array
            return [...new Set(filteredItems)];
        },
        alwaysShowItems: function () {
            return this.input.options.filter(item => {
                if (item.hasOwnProperty('always_show')) {
                    return item.always_show === true;
                }
            });
        },
        filteredLabels: function () {
            return this.filteredItems.map(item => {
                return item.label;
            });
        },
        filteredValues: function () {
            return this.filteredItems.map(item => {
                return item.value;
            });
        }
    },
    mounted: function () {
        // this.input.value is referring to the previously set value - not the EZLynx_value of the carrier!
        //this.typedOption = this.input.value;
        this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'typed_option', val: this.input.value });
    },
    methods: {
        // bottomScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
        // element : v-combobox-option-list
        // @scroll="bottomScroll" :class="!scrolledToBottom ? 'scroll-it':''"
        //future UX feature, still need to discuss with Mike. This is ground work for an indicator that there are more elements to scroll to.
        //Since the scroll bar disapears on MacOS and other systems, it might be unclear for some users that there are more options to pick from  -G

        // if (scrollHeight - scrollTop == clientHeight || (scrollHeight - scrollTop) - .5 == clientHeight) {
        //     this.scrolledToBottom = true
        // }else{
        //     this.scrolledToBottom = false
        // }
        // },
        clickAction: function (e) {
            this.showAutocompleteDropdown = true
            if (this.input.typed_option) {
                this.inputAction(e)
            }
        },
        inputAction: function (e) {
            //Autoselect feature is buggy - g
            // if (this.filteredItems.length == 1 && (this.filteredItems[0].label.toLowerCase().indexOf(this.input.typed_option.toLowerCase()) > -1) && e.inputType != 'deleteContentBackward') {
            //     var self = this;
            //     console.log('ONLY ONE OPTION', this.filteredItems[0].label);
            //     this.input.typed_option = this.filteredItems[0].label

            //     this.showAutocompleteDropdown = false
            //     self.disabledInput = true

            //     setTimeout(function(){
            //         self.disabledInput = false
            //     },1000)
            //     return
            // }

            this.showAutocompleteDropdown = this.filteredItems.length;
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'typed_option', val: e.target.value });
        },
        blurAction: function (e) {
            //@gabriel added a feature to remove typed text if they focus out of the element and didnt pick a carrier from the list  to prevent submitting bogus data
            setTimeout(() => {
                if (!this.filteredLabels.includes(this.input.typed_option)) {
                    //this.typedOption = '';
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'typed_option', val: '' });
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: '' });
                }
                this.showAutocompleteDropdown = false;

                this.exec(e, this.input, { skipUpdate: true });
            }, 500);
        },
        display(option) {
            let show = true;

            if (!Utils.isEmpty(option.display)) {
                if (!this.fs.displayConditionals(option.display)) {
                    show = false;
                }
            }

            return show;
        },
        handleBackspace: function () {
            this.showAutocompleteDropdown = true;
        },
        select: function (index) {
            if (index || index === 0) {
                this.showAutocompleteDropdown = false;
                //this.typedOption = this.filteredItems[index].label;
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'typed_option', val: this.filteredItems[index].label });
            }
        },
        selectNext: function () {
            console.log('triggered nxt');
            if (this.showAutocompleteDropdown) {
                if (this.selectedIndex < this.filteredItems.length - 1) {
                    this.selectedIndex++;
                } else {
                    this.selectedIndex = 0;
                }
            } else {
                this.showAutocompleteDropdown = true;
            }
        },
        selectPrev: function () {
            console.log('triggered prev');
            if (this.selectedIndex > 0) {
                this.selectedIndex--;
            } else {
                this.selectedIndex = this.filteredItems.length - 1;
            }
        }
    }
};
